var _style, _g, _g2, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSad(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFE462;}\n\t.st1{fill:#FDC202;}\n\t.st2{fill:#12100E;}\n\t.st3{fill:#25B1FF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_00000091003727270859508100000011050969893830578597_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 9.9,
    cy: 9.2,
    rx: 9.2,
    ry: 9.2
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M17.5,3.9c0.6,1.2,0.9,2.5,0.9,3.9c0,5.1-4.1,9.2-9.2,9.2c-3.1,0-5.9-1.5-7.5-3.9c1.5,3.1,4.7,5.3,8.3,5.3 c5.1,0,9.2-4.1,9.2-9.2C19.2,7.2,18.5,5.4,17.5,3.9z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M14,8.2c-0.2,0.4-0.6,0.6-1.1,0.6c-0.4,0-0.9-0.2-1.1-0.6C11.8,8.1,11.7,8,11.6,8c-0.1,0-0.1,0-0.2,0 c-0.2,0.1-0.2,0.3-0.1,0.5c0.4,0.6,1,0.9,1.7,0.9c0.7,0,1.4-0.3,1.7-0.9c0.1-0.2,0-0.4-0.1-0.5S14.1,8,14,8.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M6.3,9.4C7,9.4,7.7,9.1,8,8.5c0.1-0.2,0-0.4-0.1-0.5C7.7,8,7.5,8,7.4,8.2C7.2,8.5,6.8,8.8,6.3,8.8 c-0.4,0-0.9-0.2-1.1-0.6C5.2,8.1,5.1,8,4.9,8c-0.1,0-0.1,0-0.2,0C4.6,8.2,4.5,8.4,4.6,8.5C5,9.1,5.6,9.4,6.3,9.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M9.6,12.2c-1.2,0-2.3,0.4-3.2,1.2c-0.1,0.1-0.1,0.2,0.1,0.3c0.1,0.1,0.3,0.1,0.5,0c0.7-0.7,1.7-1,2.6-1 s1.9,0.4,2.6,1c0.1,0.1,0.2,0.1,0.3,0.1c0.1,0,0.1,0,0.2,0c0.1-0.1,0.2-0.2,0.1-0.3C11.9,12.6,10.8,12.2,9.6,12.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M13.4,5.7c-0.7-0.2-1.2-0.7-1.6-1.2c0-0.1,0-0.1,0.1-0.1c0.1,0,0.2,0,0.3,0.1c0.3,0.5,0.8,0.8,1.3,1 c0.6,0.2,1.2,0.2,1.7,0c0,0,0.1,0,0.2,0c0,0,0.1,0,0.1,0.1c0.1,0.1,0.1,0.1,0,0.2C14.8,6,14.1,5.9,13.4,5.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M6.6,5.7C7.3,5.5,7.8,5,8.2,4.5c0-0.1,0-0.1-0.1-0.1c-0.1,0-0.2,0-0.3,0.1C7.5,4.9,7,5.3,6.5,5.5 c-0.6,0.2-1.2,0.2-1.7,0c0,0-0.1,0-0.2,0c0,0-0.1,0-0.1,0.1c-0.1,0.1-0.1,0.1,0,0.2C5.2,6,5.9,5.9,6.6,5.7z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "sad"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M5.3,17.7c-1.3,0-2.4-1.1-2.4-2.4c0-0.7,0.7-2.4,1.7-4.5c0.2-0.6,1.1-0.6,1.3,0c0.9,2.1,1.7,3.7,1.7,4.5 C7.7,16.6,6.6,17.7,5.3,17.7z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSad);
export default __webpack_public_path__ + "static/media/icon-sad.2ecd3410c41a4e717da16c5f692a3754.svg";
export { ForwardRef as ReactComponent };